import React from 'react';

const CardIndex = () => {
  return <div>Card Index</div>;
};

export default CardIndex;
